<script setup>
import { useHead } from '@unhead/vue';
import BrandForm from '../../scripts/components/contactForm/BrandForm.vue';
import CarouselGeneric from '../../scripts/components/CarouselGeneric.vue';

const imagesGlob = import.meta.glob('../../images/brands/nimble/products/*', { eager: true });

useHead({});

const products = [
	{
		title: " Apollo Wireless Pad", 
		src: imagesGlob["../../images/brands/nimble/products/swaggerproductpagewebsiteholidaykitsnimble-apollo-wireless-pad.png"].default
	},
	{
		title: "Champ Pro Portable Charger 20K", 
		src: imagesGlob["../../images/brands/nimble/products/swaggerproductpagewebsiteholidaykitsnimblechamp-pro-portable-charger-20k.png"].default
	},
	{
		title: "Wally Subnano 20W USB-C Wall Charger", 
		src: imagesGlob["../../images/brands/nimble/products/swaggerproductpagewebsiteholidaykitsnimblewally-subnano-20w-usbc-wall-charger.png"].default
	},
	{
		title: "Pivot 3-in-1 Wireless Compact Charger", 
		src: imagesGlob["../../images/brands/nimble/products/swaggerproductpagewebsiteholidaykitsnimblepivot-3in1-wireless-compact-charger.png"].default
	},
	{
		title: "Champ Portable Charger 10K USB-C", 
		src: imagesGlob["../../images/brands/nimble/products/swaggerproductpagewebsiteholidaykitsnimblechamp-portable-charger-10k-usbc.png"].default
	},
	{
		title: "Fold 3-in-1 Wireless Charger", 
		src: imagesGlob["../../images/brands/nimble/products/swaggerproductpagewebsiteholidaykitsnimblefold-3in1-wireless-charger.png"].default
	},
	{
		title: "Champ Lite Portable Charge 5K - 5,200mAh", 
		src: imagesGlob["../../images/brands/nimble/products/swaggerproductpagewebsiteholidaykitsnimblechamp-lite-portable-charge-5k--5200mah.png"].default
	},
]
</script>

<template lang="pug">
.page.page--brand.nimble
	section.hero
		.hero__bg
		.hero__content
			.copy
				img(src='@static/images/brands/nimble/logo.png')
				h1 Custom Nimble
			.image
				img(src='@static/images/brands/nimble/hero.png')
	section.section.section--subhero
		.section__content
			.copy
				h2 Thoughtful Technology, Made from Sustainable Materials.
				p Custom Nimble by Swagger brings your brand into the digital age with smart, sustainable tech that serves and supports. As a Certified B Corporation, Nimble crafts beautifully designed power accessories such as chargers, cables, and adapters that pair cutting-edge performance with planet-conscious materials. Thoughtfully engineered from ethically sourced components, every product reflects Nimble's belief that technology should empower without costing the Earth.0				

	.page__content
		section.section.section--products
			.section__content
				CarouselGeneric(name="productCarousel" :innerNav="false" :perPage="{ 0: 1, 751: 3 }")
					.product-card(v-for="product in products")
						.product-card__image
							img(:src="product.src")
						.product-card__text
							p {{product.title}}
							

		
		section.section.section--form
			.section__content
				h2 Love this brand?<br/>Let's make something cool together
				p Please fill out this form so we can help you with your upcoming project.
				.form-wrap
					BrandForm(formName="nimble")
		
		section.section.section--detail
			.stripe
				img(src='@static/images/brands/nimble/banner.jpg')
			.section__content
				.copy
					h2 POWERED BY PURPOSE, FUELED BY RESPONSIBILITY
					p Nimble stands apart by blending high performance with low environmental impact. Their accessories proudly carry the B Corp badge, certified for meeting rigorous standards of environmental and social responsibility. Each piece is designed to reduce e-waste through free recycling programs, and their materials are vetted with the Global Recycled Standard and backed by an Ecovadis gold sustainability rating, along with a Climate Label certification. Nimble proves that innovation does not need to be wasteful. It can be regenerative.
		
		section.section.section--foot
			.bg
			.section__content

</template>

<style></style>